import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import jhsLogo from "../images/jhsLogo.svg";
import jpsLogo from "../images/jpsLogo.jpeg";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAcademicYear } from "./AcademicYearContext";

const navItems = ["Home"];

function Layout() {
  const [year, setYear] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [years, setYears] = useState([]); // Stores fetched years
  const [yearAnchorEl, setYearAnchorEl] = useState(null);

  const { academicYearId, setAcademicYearId } = useAcademicYear();
  const { selectedYear, setSelectedYear } = useAcademicYear();

  const instituteId = localStorage.getItem("instituteId");

  const instituteConfig = {
    1: { logo: jhsLogo, height: null, width: null, mixBlendMode: "normal", marginLeft: "-0.5rem" },
    2: { logo: jpsLogo, height: '106px', width: 200,mixBlendMode: "screen",
    },
  };
   
  const roleName = localStorage.getItem("roleName");
  const isSuperUser = roleName === "Super User";
  
  // Super User: Always use JHS logo. Other users: Use their institute logo
  const currentInstitute = isSuperUser ? instituteConfig[1] : instituteConfig[Number(instituteId)] || instituteConfig[1];
  const handleYearClick = (event) => {
    setYearAnchorEl(event.currentTarget); // Opens the dropdown
  };

  const handleYearSelect = (year, yearId) => {
    setSelectedYear(year); // Update selected year
    setAcademicYearId(yearId); // Update academic year ID
    setYearAnchorEl(null); // Close dropdown

    localStorage.setItem("selectedYear", year); // Save user selection
    localStorage.setItem("selectedYearId", yearId);
  };
  useEffect(() => {
    const handleRefresh = () => {
      localStorage.removeItem("selectedYear");
      localStorage.removeItem("selectedYearId");
    };

    window.addEventListener("beforeunload", handleRefresh);

    return () => {
      window.removeEventListener("beforeunload", handleRefresh);
    };
  }, []);

  const handleYearClose = () => {
    setYearAnchorEl(null);
  };

  // Tejashwini
  useEffect(() => {
    // Check JWT token for authentication
    const roleID = localStorage.getItem("roleID");
    if (!roleID) {
      console.log("Redirecting to signin");
      navigate("/signin"); // Redirect to sign-in if not authenticated
    }

    axios
      .get(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/academicyear/getAcademicYear`,
      )
      .then((response) => {
        setYears(response.data);
        setYear(response.data[0].academic_year);

        const savedYear = localStorage.getItem("selectedYear");
        const savedYearId = localStorage.getItem("selectedYearId");

        if (savedYear && savedYearId) {
          setSelectedYear(savedYear);
          setAcademicYearId(savedYearId);
        } else {
          setSelectedYear(response.data[0].academic_year); // Set default year
          setAcademicYearId(response.data[0].academic_id);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [navigate]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleCloseMenu();
    navigate("/profile"); // Navigate to profile
  };

  const handleSignOut = () => {
    signOut();
    localStorage.clear(); // Clear the session
  };

  const signOut = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/send-otp/signOut", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        academic_year_id: academicYearId,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        window.location.replace(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/signin",
        );
      })
      .catch((error) => console.error("Error fetching fees slab:", error));
  };

  const handlehome = () => {
    const role = localStorage.getItem("roleName");
    if (role === "Super User") {
      // Super user: navigate to manage-settings only if not already on manage-settings
      if (location.pathname !== "/manage-settings") {
        navigate("/manage-settings");
      }
      // If already on manage-settings, do nothing (stay on same component)
    } else if (role === "Administrator") {
      navigate("/dashboard");
    } else if (role === "Data Entry Operator") {
      navigate("/dashboard");
    } else if (role === "Accountant") {
      navigate("/fees-management");
    } else if (role === "Inventory Manager") {
      navigate("/erp-management");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div>
      <Box sx={{ display: "flex", marginBottom: "6.5rem" }}>
        <CssBaseline />
        <AppBar component="nav" style={{ background: "#0A64A2" }}>
          <Toolbar disableGutters sx={{ px: 2 }}>
           <Typography
  variant="h6"
  component="div"
  sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" }, alignItems: "center" }}
>
  <img
    src={currentInstitute.logo}
    alt="Institute Logo"
    style={{
      marginRight: "1rem",
      marginLeft: currentInstitute.marginLeft || "-2rem",  // ← uses config value or fallback
      padding: "0.5rem",
      ...(currentInstitute.height && { height: currentInstitute.height }),
      ...(currentInstitute.width && { width: currentInstitute.width }),
      objectFit: "contain",
      mixBlendMode: currentInstitute.mixBlendMode,
    }}
  />
</Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  onClick={handlehome}
                  sx={{
                    color: "#fff",
                    fontSize: "1rem",
                    left: "15px",
                    top: "1px",
                  }}
                >
                  {item}
                </Button>
              ))}
               <Button
                sx={{
                  color: "#fff",
                  fontSize: "1.1rem",
                  alignItems: "center",
                  left: "0.9em",
                  paddingRight: "17px",
                }}
                onClick={handleMenuClick}
                startIcon={<AccountCircleIcon fontSize="large" />}
              >
                <ArrowDropDownIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem onClick={handleProfile}>Profile</MenuItem>
                <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
              </Menu>
              <span
                style={{
                  marginTop: "10px",
                  textAlign: "right",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  paddingLeft: "9px",
                }}
              >
                <span style={{ paddingRight: "10px" }}>{selectedYear}</span>
                <Button
                  sx={{
                    color: "#fff",
                    fontSize: "1.1rem",
                    minWidth: "auto",
                    padding: 0,
                  }}
                  onClick={handleYearClick}
                >
                  <ArrowDropDownIcon />
                </Button>

                {/* Year Dropdown Menu */}
                <Menu
                  anchorEl={yearAnchorEl}
                  open={Boolean(yearAnchorEl)}
                  onClose={handleYearClose}
                >
                  {years.length > 0 ? (
                    years.map((year) => (
                      <MenuItem
                        key={year.academic_id}
                        onClick={() =>
                          handleYearSelect(year.academic_year, year.academic_id)
                        }
                      >
                        {year.academic_year}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>Loading...</MenuItem>
                  )}
                </Menu>
              </span>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}

export default Layout;